import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import settings from './global/config/settings';

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    debug: settings.DEBUG_I18N,
    backend: {
      loadPath: `locales/{{lng}}/translation.json?version=${settings.CI_COMMIT_HASH ?? 'local'}`,
      requestOptions: {
        cache: 'no-store'
      }
    },
    lng: settings.LANGUAGE,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
